import T from "./T";

const {
  DOLLAR,
  PERCENTAGE,
  LIVE,
  TEST,
  TRUE,
  FALSE,
  LENDER_ACCOUNT_NAME,
  FUNDING_TYPE,
  NAME_OF_BANK,
  BSB,
  ACCOUNT_NUMBER,
  BALANCE,
  INTEREST,
} = T;

export const TRANSACTION_FEE_DEDUCTION_TYPES = [DOLLAR, PERCENTAGE];
export const TRUE_OR_FALSE_OPTIONS = [TRUE, FALSE];
export const BANKING_ENVIRONMENT_LIST = [LIVE, TEST];

export const VIEW_BANKING_TABLE_HEADER = [
  { label: LENDER_ACCOUNT_NAME },
  { label: FUNDING_TYPE },
  { label: NAME_OF_BANK },
  { label: BSB },
  { label: ACCOUNT_NUMBER },
  { label: BALANCE },
  { label: INTEREST },
];

export const EDIT_BANKING_TABLE_HEADER = [
  // { label: S_NO },
  { label: LENDER_ACCOUNT_NAME },
  { label: FUNDING_TYPE },
  { label: NAME_OF_BANK },
  { label: BSB },
  { label: ACCOUNT_NUMBER },
  { label: BALANCE },
  { label: INTEREST },
];

export const businessUnitFeeTypes = [
  {
    label: T.COMPANY,
    value: T.COMPANY.toUpperCase(),
  },
  {
    label: T.FREE,
    value: T.FREE.toUpperCase(),
  },
];

export const VIEW_LENDER_TABLE_HEADER = [
  { label: T.NAME },
  { label: T.START_DATE },
  { label: T.NAME_OF_BANK },
  { label: T.ACCOUNT_NAME },
  { label: T.BSB },
  { label: T.ACCOUNT_NUMBER },
  { label: T.CREDIT },
  { label: T.DEBIT },
  { label: T.BALANCE },
  { label: T.INTEREST_RATE },
  { label: T.STATUS },
  { label: T.ACTION },
];

export const FUNDING_TYPES = [
  "SELF_FINANCED",
  "EXTERNAL_FINANCED",
  "CASHD_FINANCED",
  "SELF_CASHD_FINANCED",
];

export const FUNDING_TYPE_OPTIONS = FUNDING_TYPES.map(f => ({ label: f, value: f}))

export const CURRENCY_TYPE_OPTIONS = [
  {
    label: T.DOLLAR,
    value: T.DOLLARTEXT,
  },
  {
    label: T.PERCENTAGE,
    value: T.PERCENT,
  },
];
